module.exports = __webpack_public_path__ + "static/media/Nikhil Mane.78db2253.png";